<template>
<div>
  <van-field label-width="9.2rem" :v-model="timeVmodel" :required="timeRequire && !disabled" :name="timeName" :value="timeValue" placeholder="请选择" input-align="right" readonly :right-icon="disabled ? '' : 'arrow'" @click="!disabled && showTime()" :rules="!disabled ? [{ validator:validatorTime, message: '请选择'+timeLabel }] : []">
    <template #label>
      <span class="input-left-label-hq">{{timeLabel}}</span>
    </template>
  </van-field>

  <van-popup v-model="showTimeVmodel" position="bottom" @close="closePopup">
    <van-datetime-picker type="date" @cancel="onCancelDate" @confirm="onConfirmDate" :min-date="minDate" :max-date="maxDate" :formatter="formatter" />
  </van-popup>

</div>
</template>

<script>
import {
  Toast
} from 'vant';
import store from '@/store'
export default {
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(2099, 11, 31),
      currentDate: new Date(),
      showTimeVmodel: false
    }
  },
  props: {
    timeVmodel: {
      type: String,
      default: ""
    },
    timeName: {
      type: String,
      default: ""
    },
    timeLabel: {
      type: String,
      default: ""
    },
    timeValue: {
      type: String,
      default: ""
    },
    timeRequire:{
      type:Boolean,
      default:true
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },

  methods: {
    validatorTime(val) {
      if(this.timeRequire)
      {
        if (!val) {
          Toast.fail('请填写' + this.timeLabel);
          return false;
        }

        if(val < this.currentDate)
        {
          Toast.fail('请选择' + this.timeLabel+'正确日期');
          return false;
        }
        return val;
      }
    },
    onConfirmDate() {
      var confirmDate = `${this.value1}-${this.value2}-${this.value3}`;

      this.$emit('getYxq', confirmDate)
      this.onCancelDate()
    },
    onCancelDate() {
      this.showTimeVmodel = false
      this.$emit('close')
    },
    showTime() {
      store.state.isFirstTime && this.$driverObj.destroy()
      this.showTimeVmodel = true;
    },
    closePopup() {
      this.$emit('close')
    },

    formatter(type, value) {
      if (type === 'year') {
        this.value1 = value // 可以拿到当前点击的数值
        return `${value}年`
      } else if (type === 'month') {
        this.value2 = value
        return `${value}月`
      }
      this.value3 = value
      return `${value}日`
    },

  },
}
</script>
<style lang="scss" scoped>
.by-red {
    color: red;
    padding: 0 3px;
    font-size: 14px;
}
</style>
